import { Col, Row } from "antd";
import {DollarCircleFilled,PhoneFilled,ToolFilled } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLabList,  getTemperatures,  insertTemperatureInstallRequestList } from "../../api/api";
import FormContainer from "../../components/FormContainer/FormContainer";
import CustomSelect from "../../components/_common/CustomSelect";
import CustomTextArea from "../../components/_common/CustomTextArea";
import Input from "../../components/_common/Input";
import { UpdateLabList } from "../../redux/reducers/lablistSlice";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import {  TemperatureInstallRequestForm } from "../../utility/validationRules";
import {InfoContainer, InfoText, InfoTextRed, StyledContainer } from "./styles";
import { UpdateTemperatureList } from "../../redux/reducers/temperatureListSlice";

const NewTempratureInstallRequest = () => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(TemperatureInstallRequestForm) as any
    const [isLoading,setIsLoading] = useState(true);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [choosenTemperature,setChoosenTemperature] = useState({str_TemperatureName:"",int_Price:0});
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(()=>{

        if (myStore.labList.list && myStore.temperatureList.list) setIsLoading(false);
        if (!myStore.labList.list) loadLabs(); 
        if (!myStore.temperatureList.list) loadTemperatures();

        if (myStore.auth.loginType === "labuser" ) {
            setValues((values:any) => ({
                ...values,
                ["lab"]: myStore.auth.userId,
              }));
        }


    },[])


    const loadLabs = () => {

        getLabList()
        .then((result:any) => {
            console.log(result.data.data);
            dispatch(UpdateLabList({labList:result.data.data}))
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }

    const loadTemperatures = () => {

        getTemperatures()
        .then((result:any) => {
            dispatch(UpdateTemperatureList({temperatureList:result.data.data}))
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    const FormSubmit = (e:any) => {
        e.preventDefault();
        
        let error= TemperatureInstallRequestForm(values);
        if (Object.keys(error).length == 0)
        {

            setIsSubmiting(true)

            insertTemperatureInstallRequestList(Number(values.temperature),Number(values.lab),values.mobile,values.description ? values.description : "",values.countRefrigerator? values.countRefrigerator:0)
            .then((result:any) => {
                console.log(result);
                setIsSubmiting(false)
                navigate("/" + myStore.auth.loginType + "/temperatureInstallRequest");
                sucessNotify("ثبت با موفقیت انجام شد")
            })
            .catch((error) => {
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage,undefined,5000)
            })

        }
        else
        {
          setErrors(error);
        }
        
    }

    const temperatureHandleChanges = (event:any) => {
        handleChange(event);

        console.log(event)
        console.log(event.target.value);

        let selectedTemperature = myStore.temperatureList.list.find((temperature: any) => temperature.prk_Tbl_TemperatureInfo_AutoID == event.target.value);
        setChoosenTemperature(selectedTemperature);
    }

    return(
        <StyledContainer>

           <FormContainer title="درخواست نصب دماسنج جدید" onSubmit={FormSubmit} isLoading={isLoading} isSubmiting={isSubmiting}  > 
                    <Row>

                        <Col lg={6} md={6} sm={12} xs={24}>
                            <CustomSelect
                                name="temperature"
                                placeholder="دماسنج"
                                itemList={myStore.temperatureList.list}
                                value={values.temperature || ""}
                                onChange={temperatureHandleChanges}
                                valueObjectField={"prk_Tbl_TemperatureInfo_AutoID"}
                                displayObjectField={"str_TemperatureName"}

                            />
                            <ValidationType type="temperature" />
                        </Col>

                        <Col lg={6} md={6} sm={12} xs={24}>
                            <CustomSelect
                                name="lab"
                                placeholder="آزمایشگاه"
                                itemList={myStore.labList.list}
                                value={values.lab || ""}
                                onChange={handleChange}
                                valueObjectField={"prk_AndriodLab_AutoID"}
                                displayObjectField={"str_LabPersianName"}
                                disabled = {myStore.auth.loginType === "labuser" ? true : false}
                            />
                            <ValidationType type="lab" />
                        </Col>

                        <Col lg={6} md={6} sm={12} xs={24}>
                            <Input
                                type="text"
                                name="mobile"
                                placeholder="موبایل"
                                value={values.mobile || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="mobile" />
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={24}>
                            <Input
                                type="text"
                                name="countRefrigerator"
                                placeholder="تعداد یخچال"
                                value={values.countRefrigerator || ""}
                                onChange={handleChange}
                            />
                            {/* <ValidationType type="mobile" /> */}
                        </Col>

                    </Row>
                    
                    <Row>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <CustomTextArea
                                name="description"
                                placeholder="توضیحات"
                                value={values.description || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="description" />
                        </Col>
                    </Row>
                    <InfoContainer>
                        
                        <Row>
                                <Col>
                                    <DollarCircleFilled style={{ color: 'blue',fontSize: '24px' }} />
                                </Col>

                                <Col lg={23} md={23} sm={23} xs={23}>
                                 {choosenTemperature.int_Price !== 0 &&  
                                    <InfoText>هزینه نصب  <InfoTextRed>{choosenTemperature.str_TemperatureName}</InfoTextRed>  
                                    <InfoTextRed>{choosenTemperature.int_Price}</InfoTextRed>ریال می باشد</InfoText>
                                 } 
                                </Col>
                        </Row>

                        {myStore.auth.loginType === 'labuser' && (
                            <>
                                <Row>
                                        <Col>
                                            <ToolFilled  style={{ color: myStore.auth.loginType === 'labuser' && myStore.auth.taxInfo.Bit_IsTax === true ? 'blue' : 'orange',fontSize: '24px' }} />
                                        </Col>

                                        {myStore.auth.loginType === 'labuser' && myStore.auth.taxInfo.Bit_IsTax === true && (
                                            <Col lg={23} md={23} sm={23} xs={23}>
                                                <InfoText>بعد از ثبت درخواست و پرداخت آنلاین ، همکاران واحد پشتیبانی با شما تماس خواهد گرفت</InfoText>
                                            </Col>
                                        )}
                                        {myStore.auth.loginType === 'labuser' && myStore.auth.taxInfo.Bit_IsTax === false && (
                                            <Col lg={23} md={23} sm={23} xs={23}>
                                                <InfoText>آزمایشگاه مالیانی نمی باشد به همین دلیل امکان پرداخت آنلاین نمی باشد. برای پرداخت با قسمت مالی شرکت هماهنگ نمایید</InfoText>
                                            </Col>
                                        )}
                                </Row>
                                <Row>
                                        <Col>
                                            <PhoneFilled  style={{ color: 'blue',fontSize: '24px' }} />
                                        </Col>
                                        <Col lg={23} md={23} sm={23} xs={23}>
                                            <InfoText>در صورتی که دماسنج مورد نظر شما در لیست دماسنج های شرکت وجود نداشت لطفا با شرکت تماس بفرمایید</InfoText>
                                        </Col>
                                </Row>
                            </>
                        )}

                    </InfoContainer>

           </FormContainer>

        </StyledContainer>
    )
}

export default NewTempratureInstallRequest;